<script lang="ts">
	//Design System
	import { Alert, Text, Token } from '@Shelly/shelly-design-system';
	//Helpers
	import { WHEN_WIZARD_STEPS_INDEXES } from '../../../helpers/when-wizard-helpers';
	import { format } from 'svelte-i18n';
	//Props
	export let sceneData: any = {};
	export let active = { operator: '', value: '' };
	export let id = '',
		subtitle = '',
		sensor_name,
		add_info_ind,
		input_index,
		key_values = [];
	// Handler props
	export let handle_condition_threshold: (item: any) => void;

	let errorMessage = '';
	let selectedKey = active?.value;

	/**
	 * Validate user input and set error message if input is invalid
	 * @returns {bool} - true if input is valid
	 */
	function validateInput(): boolean {
		if (key_values?.find((item) => item?.key === selectedKey) === undefined) {
			// if (import.meta.env.DEV) {
			// 	console.warn('Invalid Key Value Condition Selected', selectedKey);
			// }
			errorMessage = '';
			return false;
		}

		if (typeof selectedKey === 'undefined' || selectedKey === '') {
			errorMessage = $format('error_invalid_option', {
				default: 'The selected option has invalid properties. Please, select a valid option.',
			});
			return false;
		}
		errorMessage = '';
		return true;
	}

	/**
	 * Handle selection of key value condition
	 * @param {string} newKey - selected option key
	 */
	const handle_key_value_condition = (newKey: string) => {
		selectedKey = newKey;
		handle_condition_threshold({
			id,
			operator: 'equal',
			value: newKey,
			sensor_name,
			add_info_ind,
			input_index,
		});

		validateKeyValueCondition();
	};
	/**
	 * Validate key value condition
	 */
	const validateKeyValueCondition = () => {
		sceneData.isValid = validateInput();

		sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.DEVICE_PROPS_STEP;
	};

	$: title_text =
		subtitle ||
		$format('title_scene_condition_with_input', {
			default: `When {value} is`,
			values: { value: sceneData?.selectedDeviceProp?.title },
		});
	validateKeyValueCondition();
</script>

<Text class="mt-l mb-s" styleType="h2">
	{title_text}
</Text>
{#if errorMessage}
	<Alert class="mb-s" heading={errorMessage} type={'danger'} />
{/if}
<div class="d-flex flex-wrap" style="gap:var(--spacing-s)">
	{#each key_values as _item, i}
		<Token
			id="token-u8nficq"
			size="m"
			title={_item?.value || $format('unknown_option', { default: 'Unknown option' })}
			selected={_item.key === selectedKey}
			icon={_item?.icon}
			on:click={() => handle_key_value_condition(_item.key)}
		/>
	{/each}
</div>
